import React, { createContext, useContext, useMemo } from "react"

// Injection seam, matching FuneralUIProvider. The host supplies the API base URL;
// this package reads no process.env and imports nothing host-specific (no gatsby),
// which is what lets admin/dashboard consume the same components.
const StatusUIContext = createContext(null)

export function StatusUIProvider({ apiBaseUrl, pollIntervalMs = 60000, children }) {
  const value = useMemo(
    () => ({ apiBaseUrl, pollIntervalMs }),
    [apiBaseUrl, pollIntervalMs]
  )

  return (
    <StatusUIContext.Provider value={value}>{children}</StatusUIContext.Provider>
  )
}

export function useStatusConfig() {
  const ctx = useContext(StatusUIContext)
  if (!ctx) {
    throw new Error(
      "[@evertech/status-ui] Missing <StatusUIProvider>. Wrap your app " +
        "(e.g. via Gatsby wrapRootElement) before rendering status components."
    )
  }
  return ctx
}
